var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.9987 1.33337C4.31679 1.33337 1.33203 4.31814 1.33203 8.00004C1.33203 11.6819 4.31679 14.6667 7.9987 14.6667C11.6806 14.6667 14.6654 11.6819 14.6654 8.00004C14.6654 4.31814 11.6806 1.33337 7.9987 1.33337ZM7.17766 4.26532C7.17766 4.04835 7.26385 3.84027 7.41727 3.68685C7.57069 3.53343 7.77877 3.44724 7.99573 3.44724C8.2127 3.44724 8.42078 3.53343 8.5742 3.68685C8.72762 3.84027 8.81381 4.04835 8.81382 4.26532V9.00189C8.81382 9.21886 8.72762 9.42694 8.5742 9.58036C8.42078 9.73378 8.2127 9.81997 7.99573 9.81997C7.77877 9.81997 7.57069 9.73378 7.41727 9.58036C7.26385 9.42694 7.17766 9.21886 7.17766 9.00189V4.26532ZM8.716 12.2535C8.55055 12.4167 8.33369 12.5175 8.10228 12.5389C7.87088 12.5602 7.63922 12.5007 7.44671 12.3706C7.2542 12.2404 7.11272 12.0476 7.04634 11.8249C6.97995 11.6022 6.99276 11.3633 7.08258 11.149C7.17241 10.9347 7.3337 10.7581 7.53903 10.6493C7.74436 10.5404 7.98104 10.5061 8.20884 10.5521C8.43663 10.598 8.64147 10.7215 8.78851 10.9015C8.93555 11.0814 9.01571 11.3067 9.01537 11.5391C9.01649 11.6723 8.99052 11.8042 8.93906 11.927C8.88759 12.0498 8.81171 12.1609 8.716 12.2535Z",
    fill: "#D9B46B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviseIcon);
export default __webpack_public_path__ + "static/media/revise-icon.1a53a54b.svg";
export { ForwardRef as ReactComponent };